import { message } from "antd";
import { Copy, Info, Trash2 } from "lucide-react";
import React, { useContext, useEffect, useMemo } from "react";
import { useCancelableDebouncedRequest } from "../../../../hooks/useCancelableDebouncedRequest ";
import { Store } from "../../../../store";
import { transformElement } from "../../../../utils/helpers";
import { deleteLayoutObjectApi, duplicateLayoutObjectApi } from "../../services/layoutObjectService";
import "./LayoutObjectContextMenu.css";

const LayoutObjectContextMenu = React.memo(({ menuRef, left, top, object, closeMenu, showProperties }) => {
  const { dispatch } = useContext(Store);
  const saveChangesToDB = useCancelableDebouncedRequest(250);

  const handleDuplicate = async () => {
    try {
      const response = await saveChangesToDB(duplicateLayoutObjectApi, object.id || "");
      const data = response?.data?.data;
      dispatch({ type: "ADD_ELEMENT", payload: transformElement(data) });
    } catch (error) {
      message.error("Failed to duplicate layout object");
      console.log("error", error);
    } finally {
      closeMenu();
    }
  };

  const handleDelete = async () => {
    try {
      const response = await saveChangesToDB(deleteLayoutObjectApi, object.id || "");
      const data = response?.data?.data;
      dispatch({ type: "REMOVE_ELEMENT", payload: object });
    } catch (error) {
      message.error("Failed to delete layout object");
      console.log("error", error);
    } finally {
      closeMenu();
    }
  };

  const handleProperties = () => {
    try {
      showProperties(object);
      closeMenu();
    } catch (error) {
      message.error("Failed to open properties");
      console.log("error", error);
    }
  };

  const menuItems = useMemo(
    () => [
      // {
      //   icon: Copy,
      //   label: "Copy",
      //   shortcut: "Ctrl+C",
      //   action: () => console.log("Copy"),
      //   color: "text-blue-600",
      // },
      // {
      //   icon: Move,
      //   label: "Move",
      //   shortcut: "M",
      //   action: () => console.log("Move"),
      //   color: "text-green-600",
      // },
      // {
      //   icon: RotateCw,
      //   label: "Rotate",
      //   shortcut: "R",
      //   action: () => console.log("Rotate"),
      //   color: "text-purple-600",
      // },
      // { type: "divider" },
      {
        icon: Copy,
        label: "Duplicate",
        shortcut: "Ctrl+D",
        action: () => handleDuplicate(),
        color: "text-blue-600",
      },
      //   {
      //     icon: Eye,
      //     label: "Isolate",
      //     // shortcut: "I",
      //     action: () => console.log("Isolate"),
      //     color: "text-amber-600",
      //   },
      //   {
      //     icon: EyeOff,
      //     label: "Hide",
      //     // shortcut: "H",
      //     action: () => console.log("Hide"),
      //     color: "text-gray-600",
      //   },
      //   {
      //     icon: Layers,
      //     label: "Show All",
      //     shortcut: "Shift+H",
      //     action: () => console.log("Show All"),
      //     color: "text-gray-600",
      //   },
      { type: "divider" },
      {
        icon: Info,
        label: "Properties",
        shortcut: "P",
        action: () => handleProperties(),
        color: "text-indigo-600",
      },
      { type: "divider" },
      {
        icon: Trash2,
        label: "Delete",
        shortcut: "Del",
        action: () => handleDelete(),
        color: "text-red-600",
        danger: true,
      },
    ],
    []
  );

  const handleItemClick = (item) => {
    if (item.action) {
      item.action();
    }
  };

  //   on component rendered listen for ctrl+d, ctrl+i, ctrl+h, ctrl+p, del
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "d" && event.ctrlKey) {
        handleDuplicate();
      } else if (event.key === "i" && event.ctrlKey) {
        // handleIsolate();
      } else if (event.key === "h" && event.ctrlKey) {
        // handleHide();
      } else if (event.key === "p") {
        handleProperties();
      } else if (event.key === "Delete") {
        handleDelete();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <>
      <div
        ref={menuRef}
        className="object-context-menu"
        style={{
          left: `${left}px`,
          top: `${top}px`,
          minWidth: "240px",
          zIndex: 9999,
          position: "absolute",
        }}
        onContextMenu={(e) => e.preventDefault()}
      >
        {/* Header */}
        <div className="ocm-header">
          <p className="ocm-header-title">{object?.name || "Object"}</p>
        </div>

        {/* Menu Items */}
        <div className="ocm-items">
          {menuItems.map((item, index) => {
            if (item.type === "divider") {
              return <div key={index} className="ocm-divider" />;
            }

            const Icon = item.icon;
            return (
              <button key={index} onClick={() => handleItemClick(item)} className={`ocm-item ${item.danger ? "ocm-item--danger" : ""}`} type="button">
                <div className="ocm-left">
                  <Icon size={18} className={`ocm-icon ${item.color || ""}`} aria-hidden="true" />
                  <span className={`ocm-label ${item.danger ? "ocm-label--danger" : ""}`}>{item.label}</span>
                </div>

                {item.shortcut && <span className="ocm-shortcut">{item.shortcut}</span>}
              </button>
            );
          })}
        </div>

        {/* Footer */}
        {/* <div className="ocm-footer">
                <p className="ocm-footer-text">Right-click for more options</p>
              </div> */}
      </div>
    </>
  );
});

export default LayoutObjectContextMenu;
